<div class="container">
    <feature-toggle-provider [features]="configService.getSelfServiceConfig()">
        <div class="d-md-none">
            <div class="avatar-icon-container d-flex mb-2">
                <h2 *ngIf="!me?.avatarLink" class="m-auto" style="text-transform: uppercase">{{ shortName }}</h2>
                <img *ngIf="me?.avatarLink" [src]="me?.avatarLink" alt="" class="" />
            </div>
            <h2>{{ me?.name?.firstName }} {{ me?.name?.familyName }}</h2>
            <h3 *ngIf="me?.businessRoles?.length > 0 && !isCustomerLite" class="text-grey">
                {{ me?.businessRoles[0] }}
            </h3>
            <hr />
        </div>
        <ul class="m-0 d-lg-flex flex-lg-wrap d-inline flex-nowrap">
            <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a routerLink="" (click)="navItemClick.emit()">
                    <!-- Overview -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.OVERVIEW.TITLE' | translate }}
                </a>
            </li>
            <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a routerLink="personal-data" (click)="navItemClick.emit()">
                    <!-- Personal data -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.PERSONAL_DATA.TITLE' | translate }}
                </a>
            </li>
            <li
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                *featureToggle="'enableCompanyData'"
            >
                <a routerLink="company-data" (click)="navItemClick.emit()">
                    <!-- Company data -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.COMPANY_DATA.TITLE' | translate }}
                </a>
            </li>
            <li
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                *featureToggle="'enableNotifications'"
            >
                <a routerLink="notifications" (click)="navItemClick.emit()">
                    <!-- Notifications -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.NOTIFICATIONS.TITLE' | translate }}
                </a>
            </li>
            <li routerLinkActive="active" *featureToggle="'enableEmployees'">
                <a routerLink="employees" (click)="navItemClick.emit()">
                    <!-- Employees -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.EMPLOYEES.TITLE' | translate }}
                </a>
            </li>
            <li routerLinkActive="active" *featureToggle="'enableRolesAndPermissions'">
                <a routerLink="roles-and-permissions" (click)="navItemClick.emit()">
                    <!-- Roles and permissions -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.ROLES.TITLE' | translate }}
                </a>
            </li>
            <li routerLinkActive="active" *featureToggle="'enablePurchasesAndSubscriptions'">
                <a routerLink="purchases" (click)="navItemClick.emit()">
                    <!-- Purchases and subscriptions -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.PURCHASES_AN_SUBSCRIPTIONS.TITLE' | translate }}
                </a>
            </li>
            <li routerLinkActive="active" *featureToggle="'enableSettings'">
                <a routerLink="settings" (click)="navItemClick.emit()">
                    <!-- Settings -->
                    {{ 'SELF_SERVICE.NAVIGATION.MENU_ITEM.SETTINGS.TITLE' | translate }}
                </a>
            </li>
        </ul>
    </feature-toggle-provider>
</div>
